import { getTranslatedMessages } from './translates';

$(".first-access-notfound-form input[name='phone']").mask('+99 99 99999-9999');

$('.first-access-notfound-form').validate({
    rules: {
        name: {
            required: true,
        },
        email: {
            required: true,
            email: true,
        },
        phone: {
            required: true,
        },
    },
    messages: getTranslatedMessages(),
});
